var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWdocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6153 26.129H22.6475M13.6153 21.6128H22.6475M19.6373 5.05502C19.4935 5.05371 19.3317 5.05371 19.1471 5.05371H12.4112C10.7251 5.05371 9.88135 5.05371 9.23732 5.38186C8.67081 5.67052 8.21055 6.13077 7.9219 6.69728C7.59375 7.34131 7.59375 8.18503 7.59375 9.87121V27.3336C7.59375 29.0197 7.59375 29.8624 7.9219 30.5064C8.21055 31.0729 8.67081 31.534 9.23732 31.8227C9.88073 32.1505 10.7234 32.1505 12.4063 32.1505L23.8565 32.1505C25.5393 32.1505 26.3808 32.1505 27.0242 31.8227C27.5907 31.534 28.0525 31.0729 28.3412 30.5064C28.669 29.863 28.669 29.0215 28.669 27.3387V14.5762C28.669 14.3916 28.6689 14.2298 28.6675 14.086M19.6373 5.05502C20.067 5.05894 20.3378 5.07489 20.5975 5.13721C20.9047 5.21097 21.1991 5.3326 21.4685 5.49768C21.7722 5.68381 22.033 5.94461 22.5534 6.465L27.2585 11.17C27.7792 11.6907 28.0381 11.9504 28.2243 12.2542C28.3893 12.5236 28.5115 12.8173 28.5852 13.1245C28.6475 13.3841 28.6636 13.6563 28.6675 14.086M19.6373 5.05502L19.6368 9.26908C19.6368 10.9553 19.6368 11.798 19.9649 12.4421C20.2536 13.0086 20.7138 13.4695 21.2803 13.7581C21.9237 14.086 22.7665 14.086 24.4493 14.086H28.6675",
    stroke: "white",
    strokeWidth: 1.72043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWdocuments);
export default __webpack_public_path__ + "static/media/Wdocuments.20c41eea053203e0fa39bc92b82b86f7.svg";
export { ForwardRef as ReactComponent };